import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { REFERRAL_STAGES } from "./crmPipelineShared";
import { LostDialog, CompletedDialog, AppointmentDialog } from "./CrmStageDialogs";
import { ReferralStageDialog } from "./ReferralStageDialog";
import { errMsg } from "./LoadError";

const OUTCOME_TITLES = { Lost: "Mark as Lost", "Not Interested": "Mark as Not Interested", Withdrawn: "Mark as Withdrawn" };

// Shared stage-change flow (dialogs + API) for pipeline board and record pages.
export function useStageMover({ view, onMoved, referralId }) {
  const [pending, setPending] = useState(null);

  const doMove = async (card, stage, extra = {}) => {
    try {
      if (referralId) await api.post(`/crm/auction-referrals/${referralId}/stage`, { stage, referral: extra.referral, lost_reason: extra.lost_reason || "" });
      else await api.post("/crm/pipeline/move", { store: card.store, id: card.id, stage, view, ...extra });
      toast.success(`Moved to ${stage}`);
      onMoved && onMoved();
    } catch (e) { toast.error(errMsg(e, "Could not update stage")); }
  };

  const request = async (card, stage) => {
    const isRef = view === "vendor" && REFERRAL_STAGES.includes(stage);
    const dialog = OUTCOME_TITLES[stage] || stage === "Completed" || stage === "Bought by Emerald Crown" || stage === "Appointment Booked" || isRef;
    if (!dialog) return doMove(card, stage);
    if (isRef && !referralId) {
      try {
        const { data } = await api.get("/crm/auction-referrals", { params: { store: card.store, id: card.id } });
        card = { ...card, hasReferral: data.referrals.some((r) => !r.separate && r.vendor_store === card.store && r.vendor_id === card.id) };
      } catch (e) { toast.error(errMsg(e, "Could not check existing referral")); return; }
    }
    setPending({ card, stage });
  };

  const close = () => setPending(null);
  const confirm = (extra) => { doMove(pending.card, pending.stage, extra); close(); };
  let dialog = null;
  if (pending) {
    const { stage, card } = pending;
    if (OUTCOME_TITLES[stage]) dialog = <LostDialog title={OUTCOME_TITLES[stage]} onCancel={close} onConfirm={(reason) => confirm({ lost_reason: reason })} />;
    else if (stage === "Completed" || stage === "Bought by Emerald Crown") dialog = <CompletedDialog initial={card.conversion || {}} onCancel={close} onConfirm={confirm} />;
    else if (stage === "Appointment Booked") dialog = <AppointmentDialog initial={card.appointment_at || ""} onCancel={close} onConfirm={(dt) => confirm({ appointment_at: dt })} />;
    else dialog = <ReferralStageDialog stage={stage} hasReferral={!!card.hasReferral} onCancel={close} onConfirm={confirm} />;
  }
  return { request, dialog };
}
